import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_star.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_star.svg'


const _hoisted_1 = { class: "text-gray-lp-300 text-xl font-semibold" }
const _hoisted_2 = { class: "flex flex-col justify-center items-center" }
const _hoisted_3 = { class: "text-gray-lp-300 text-2xl font-bold" }
const _hoisted_4 = { class: "text-sm text-gray-lp-800 mt-1" }
const _hoisted_5 = { class: "flex flex-row items-start mt-4 mb-6" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  alt: "star"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: "star"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  alt: "star"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  alt: "star"
}
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  alt: "star"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_1,
  alt: "star"
}
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: "star"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: "star"
}
const _hoisted_14 = {
  key: 0,
  src: _imports_0,
  alt: "star"
}
const _hoisted_15 = {
  key: 1,
  src: _imports_1,
  alt: "star"
}
const _hoisted_16 = { class: "flex rlex-row items-end justify-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.isShowModal)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        title: _ctx.$t('feedback.modal.title'),
        isCustomTitle: true,
        width: "w-667px",
        onClose: _ctx.closeModal
      }, {
        "custom-title": _withCtx(() => [
          _createVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("feedback.modal.title")), 1)
        ]),
        content: _withCtx(() => [
          _createVNode("section", _hoisted_2, [
            _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("feedback.modal.subtitle")), 1),
            _createVNode("p", _hoisted_4, [
              (_ctx.rating === 0)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("feedback.modal.rating")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.rating === 1)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("feedback.modal.disappointing")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.rating === 2)
                ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("feedback.modal.slightlyDisappointing")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.rating === 3)
                ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("feedback.modal.okay")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.rating === 4)
                ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("feedback.modal.satisfying")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.rating === 5)
                ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("feedback.modal.excellent")), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = () => (_ctx.rating = 1))
              }, [
                (_ctx.rating >= 1)
                  ? (_openBlock(), _createBlock("img", _hoisted_6))
                  : (_openBlock(), _createBlock("img", _hoisted_7))
              ]),
              _createVNode("button", {
                onClick: _cache[2] || (_cache[2] = () => (_ctx.rating = 2))
              }, [
                (_ctx.rating >= 2)
                  ? (_openBlock(), _createBlock("img", _hoisted_8))
                  : (_openBlock(), _createBlock("img", _hoisted_9))
              ]),
              _createVNode("button", {
                onClick: _cache[3] || (_cache[3] = () => (_ctx.rating = 3))
              }, [
                (_ctx.rating >= 3)
                  ? (_openBlock(), _createBlock("img", _hoisted_10))
                  : (_openBlock(), _createBlock("img", _hoisted_11))
              ]),
              _createVNode("button", {
                onClick: _cache[4] || (_cache[4] = () => (_ctx.rating = 4))
              }, [
                (_ctx.rating >= 4)
                  ? (_openBlock(), _createBlock("img", _hoisted_12))
                  : (_openBlock(), _createBlock("img", _hoisted_13))
              ]),
              _createVNode("button", {
                onClick: _cache[5] || (_cache[5] = () => (_ctx.rating = 5) || _ctx.rating >= 5)
              }, [
                (_ctx.rating >= 5)
                  ? (_openBlock(), _createBlock("img", _hoisted_14))
                  : (_openBlock(), _createBlock("img", _hoisted_15))
              ])
            ]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('feedback.modal.reviewTitle'),
              asterisk: "",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  type: "textarea",
                  maxLength: "255",
                  placeholder: _ctx.$t('feedback.modal.reviewPlaceholder'),
                  showMaxLength: true,
                  modelValue: _ctx.feedback,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.feedback = $event))
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode("section", _hoisted_16, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('feedback.modal.cancel'),
              outline: "",
              "text-color": "red-lp-100",
              onClick: _ctx.closeModal
            }, null, 8, ["title", "onClick"]),
            _createVNode(_component_LpButton, {
              title: _ctx.$t('feedback.modal.send'),
              "text-color": "white",
              disabled: _ctx.disabledSubmitButton,
              onClick: _ctx.onSubmit
            }, null, 8, ["title", "disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["title", "onClose"]))
    : _createCommentVNode("", true)
}